import { SolidifyableData } from "../../../../../core/data/SolidifyableData";
import { ResponsibleGamingSettingsData } from "../../../../model/data/ResponsibleGamingSettingsData";
import { GameConstants } from "../../constant/GameConstants";
/**
 * SetSettingsResponseData.ts
 */
export class SetSettingsResponseData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        let settings = this.data.getDataObject(GameConstants.PROPERTY_SETTINGS);
        if (settings) {
            this.settings = new ResponsibleGamingSettingsData(settings);
        }
    }
    getSettings() {
        return this.settings;
    }
}
//# sourceMappingURL=SetSettingsResponseData.js.map